import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import type { PronounEnum } from './external/bambi-api/bambiApi';

export const pronounOptions: SelectOption<PronounEnum>[] = [
  {
    label: 'He',
    value: 'he',
  },
  {
    label: 'She',
    value: 'she',
  },
  {
    label: 'They',
    value: 'they',
  },
];
